import React, { Fragment } from "react";
import { Input, Typography, Row, Col, Collapse } from "antd";
import { Field } from "formik";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";
import "./style/atv.css";
const { Panel } = Collapse;
const AtvV2 = ({ disabled, atvData }) => {
  const onChange = (key) => {};
  const getTotalLandArea = () => {
    return atvData?.property_land_areas?.reduce((acc, item) => {
      return acc + item?.area;
    }, 0);
  };
  const getFloorType = (floor) => {
    return floor?.valuation_classification?.name;
  };
  return (
    <Fragment>
      <Row>
        <Col span={12} className="column-left">
          <Field
            InputType={Input}
            component={FormInputField}
            name="type_of_structure"
            labelText="Classification"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
            defaultValue={atvData?.property_type}
          />
        </Col>
        <Col span={12} className="column-right">
          <Field
            InputType={Input}
            component={FormInputField}
            name="land_area"
            labelText="Land Area"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
            suffix="Marlas"
            defaultValue={getTotalLandArea()}
          />
        </Col>
      </Row>
      <Row>
        {atvData?.buildings
          ?.sort((a, b) => (a?.id > b?.id ? 1 : a?.id < b?.id ? -1 : 0))
          ?.map((item, index) => {
            return (
              <Col
                span={atvData?.buildings?.length === 1 ? 24 : 12}
                className={index % 2 === 0 ? `column-left` : `column-right`}
                key={item?.id}
              >
                <div className="collapse-wrapper-atv">
                  <Typography.Title level={4}>
                    Building {index + 1}
                  </Typography.Title>
                  <Collapse
                    defaultActiveKey={["1"]}
                    onChange={onChange}
                    bordered
                  >
                    {item?.data?.map((floor, index) => {
                      return (
                        <Panel
                          header={`Floor ${index + 1}`}
                          key={`floor-${index}${floor?.id}`}
                        >
                          <Field
                            InputType={Input}
                            key={getFloorType(floor)}
                            component={FormInputField}
                            name={`floor_type${floor?.id}`}
                            labelText="Floor Type"
                            // hideErrorMessage={true}
                            className="text-field"
                            disabled={disabled}
                            defaultValue={getFloorType(floor)}
                            // initialValue={getFloorType(floor)}
                          />
                          <Field
                            InputType={Input}
                            component={FormInputField}
                            name={`rcc_area${floor?.id}`}
                            labelText="RCC Covered Area"
                            className="text-field"
                            disabled={disabled}
                            suffix="sq. ft"
                            defaultValue={
                              floor?.rcc_area ? floor?.rcc_area : null
                            }
                          />
                          <Field
                            InputType={Input}
                            component={FormInputField}
                            name={`non_rcc_area${floor?.id}`}
                            labelText="Non-RCC Covered Area"
                            className="text-field"
                            disabled={disabled}
                            suffix="sq. ft"
                            defaultValue={
                              floor?.non_rcc_area ? floor?.non_rcc_area : null
                            }
                          />
                        </Panel>
                      );
                    })}
                  </Collapse>
                </div>
              </Col>
            );
          })}
      </Row>
      <Row>
        <Col span={12} className="column-left">
          <Field
            InputType={Input}
            component={FormInputField}
            name="annual_taxable_value"
            labelText="ATV"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
        <Col span={12} className="column-right">
          <Field
            InputType={Input}
            component={FormInputField}
            name="annual_tax"
            labelText="Tax Due (5% of ATV)"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
      </Row>
    </Fragment>
  );
};

export default AtvV2;
